import React from "react";
import ReactDOM from "react-dom";
import controller from "../../../../Resources/Scripts/_Shared/controller";
import LockedPmcForm from "./LockedPmcForm";

function lockedpmc(context) {
  if (!context) return;
  let originalScrollPosition = 0;
  let isMounted = false;
  const openButton = context.previousElementSibling;

  const selectedLanguage = document.querySelector("html").getAttribute("lang");

  const lockScroll = () => {
    originalScrollPosition = window.scrollY;
    document.documentElement.style.position = "fixed";
    document.documentElement.style.top = `-${originalScrollPosition}px`;
    document.documentElement.style.width = "100%";
  };

  const unlockScroll = () => {
    document.documentElement.style.removeProperty("position");
    document.documentElement.style.removeProperty("top");
    document.documentElement.style.removeProperty("width");
    window.scrollTo(0, originalScrollPosition);
  };

  const closePopup = () => {
    if (!isMounted) return;
    context.style.display = "none";
    unlockScroll();

    // Clean up React component
    const appContainer = context.querySelector("[data-app-container]");
    if (appContainer) {
      ReactDOM.unmountComponentAtNode(appContainer);
    }
    isMounted = false;

  };

  const handleDocumentClick = (e) => {
    if (e.target.closest(".facilitypage__lockedpmc__close")) {
      closePopup();
    }
  };
  
  const onSubmit = () => {
    //close modal and redirect to booking flow
    const description = context.querySelectorAll(".facilitypage__lockedpmc__description_container");
    description[0].style.display = "none";
    const heading = context.querySelectorAll(".facilitypage__lockedpmc__heading");

    if (heading.length > 0) {
        heading[0].textContent = heading[0].dataset.newheading;

        const redirectUrl = context.dataset.redirect;

        setTimeout(() => {
            closePopup();
            window.location.href = redirectUrl;
        }, 1000);
    } 
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") closePopup();
  };

  const openPopup = () => {
    if (isMounted) return;
    context.style.display = "flex";
    
    lockScroll();

    const appContainer = context.querySelector("[data-app-container]");
    if (appContainer) {
      const lockedPmcInner = context.querySelector(".facilitypage__lockedpmc__inner");
      if (lockedPmcInner) {
        ReactDOM.render(
          <LockedPmcForm 
            lang={selectedLanguage}
            onSubmit={onSubmit} 
            onSuccess={closePopup} 
            pmcId={lockedPmcInner.getAttribute("data")}
          />,
          appContainer
        );
        isMounted = true;
      }
    }
  };

  openButton.addEventListener("click", openPopup);
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("click", handleDocumentClick);

  return {
    init: () => {},
    destroy: () => {
      openButton.removeEventListener("click", openPopup);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("click", handleDocumentClick);
      closePopup();
      unlockScroll();
    },
  };
}

controller.add("pmc-locked", lockedpmc);
